export const getAnnouncements = (state) => {
  return state.announcements.list.data.data
    ? state.announcements.list.data.data
    : [];
};

export const getIsAnnouncementsFetching = (state) =>
  state.announcements.list.isFetching;

export const getIsAnnouncementsUpdatedAt = (state) =>
  state.announcements.list.updatedAt;
